import React from 'react';
import {useParams} from 'react-router-dom';
import ChannelEvaluationTasksListView from './ChannelEvaluationsTasksListView';
import RuleListView from '@/views/admin/rules/RuleListView';
import ActionListView from '@/views/admin/actions/ActionListView';

export const ChannelEvaluationTasksWrapper: React.FC = () => {
    const {channelId} = useParams<{ channelId: string }>();
    const id = channelId ? parseInt(channelId, 10) : null;
    const validId = id && !isNaN(id) ? id : null;
    return <ChannelEvaluationTasksListView activeChannelId={validId} />;
};

export const ChannelRulesWrapper: React.FC = () => {
    const {channelId} = useParams<{ channelId: string }>();
    return <RuleListView activeChannelId={channelId || '0'} />;
};

export const ChannelActionsWrapper: React.FC = () => {
    const {channelId} = useParams<{ channelId: string }>();
    return <ActionListView activeChannelId={channelId || '0'} />;
};

